<script setup lang="ts">

import CarbucksRewardsFeatures from './Components/CarbucksRewardsFeatures.vue';

</script>

<template>

    <Page>
        
        <div class="grid grid-cols-1 lg:grid-cols-3 justify-center items-center gap-4 2xl:gap-16 -mb-6">

            <div class="flex flex-col items-center gap-4 pt-6">


                <Image src="/ConsumerProposition/carbucks-rewards-logo.png"
                    class="w-3/5 mb-3" 
                />

                <!-- <div class="text-center text-sm 2xl:text-base font-semibold uppercase 
                            text-white/50 px-8">
                    3-year Program
                </div> -->

                <Image
                    src="/images/shared/WhatIsCarbucks/carbucks.png"
                    class="w-[50vw] md:w-full max-w-[320px] mx-auto 2xl:-top-4 2xl:-mb-4"
                    floor-shadow
                />

                <Video 
                    class="-mt-12"
                    src="~/video/rewards.mp4" 
                    title="Watch Video" 
                />

            </div>

            <div class="col-span-1 lg:col-span-2 flex flex-col items-center">
                <CarbucksRewardsFeatures />
            </div>

        </div>

    </Page>

</template>